import axiosInstance from '../../../../../utils/axios';
import { FundedSideCardDTO } from './models';
import { ApiError } from './errors';

export const getFundedChallenges = async (
  token: string,
): Promise<FundedSideCardDTO[]> => {
  try {
    const response = await axiosInstance.get<FundedSideCardDTO[]>(
      '/v2/funded/area',
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      },
    );
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.status === 500) {
      throw new ApiError(error.response.data.error);
    } else {
      throw new ApiError('An unexpected error occurred');
    }
  }
};
